import { failure, success } from './either.js';
export function tryToResolveJsonBody(response, path, schema, isEmptyResponseExpected = false) {
    if (response.status === 204) {
        return Promise.resolve({
            error: 'EMPTY_RESPONSE',
        });
    }
    if (!response.headers.get('content-type')?.includes('application/json')) {
        // 202 often returns empty body as well, and if we explicitly say empty response is expected, we assume that's why it's not json
        if (response.status === 202 && isEmptyResponseExpected) {
            return Promise.resolve({
                error: 'EMPTY_RESPONSE',
            });
        }
        return Promise.resolve({
            error: 'NOT_JSON',
        });
    }
    return response.json().then((responseBody) => {
        return parseResponseBody({
            response: responseBody,
            responseBodySchema: schema,
            path,
        });
    });
}
function parseResponseBody({ response, responseBodySchema, path, }) {
    const result = responseBodySchema.safeParse(response);
    if (!result.success) {
        console.error({
            path,
            response,
            error: result.error,
        });
        return failure(result.error);
    }
    return success(response);
}
export function parseRequestBody({ body, requestBodySchema, path, }) {
    if (!body) {
        return success(body);
    }
    if (!requestBodySchema) {
        return success(body);
    }
    const result = requestBodySchema.safeParse(body);
    if (!result.success) {
        console.error({
            path,
            body,
            error: result.error,
        });
        return failure(result.error);
    }
    return success(body);
}
//# sourceMappingURL=bodyUtils.js.map